import { useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../redux/store'
import { googleLogin } from '../redux/auth/actions'
import FullPageLoader from '../Components/Common/Loading/FullPageLoader'

export default function GoogleLogin() {
  const dispatch = useAppDispatch()
  const loadingMessage = useAppSelector((state) => state.auth.loadingMessage)
  const loading = useAppSelector((state) => state.auth.loading)
  const error = useAppSelector((state) => state.auth.error)
  const [hasTriggeredLogin, setHasTriggeredLogin] = useState(false)

  useEffect(() => {
    if (!hasTriggeredLogin) {
      console.log('GoogleLogin: Triggering Google login...')
      setHasTriggeredLogin(true)
      dispatch(googleLogin())
    }
  }, [dispatch, hasTriggeredLogin])

  useEffect(() => {
    console.log('GoogleLogin: Auth state changed', { loading, error, loadingMessage })
  }, [loading, error, loadingMessage])

  return <FullPageLoader message={loadingMessage} />
}
